<template>
  <div
    v-loading="loading"
    class="scheduled-export-setting"
  >
    <!-- 一覧表示 -->
    <ScheduledExportSettingList
      v-if="currentView === 'list'"
      :settings="settings"
      @create-new="handleCreateNew"
      @select-setting="handleSelectSetting"
    />

    <!-- 詳細表示 -->
    <ScheduledExportSettingShow
      v-else-if="currentView === 'detail' && selectedSetting"
      :model="selectedSetting"
      @after-delete="handleAfterDelete"
      @click-back-button="handleBackToList"
    />

    <!-- フォーム表示 -->
    <ScheduledExportSettingForm
      v-else-if="currentView === 'form'"
      :number-of-target-leads="numberOfTargetLeads"
      :number-of-leads="numberOfLeads"
      :lead-list-filter-params="leadListFilterParams"
      @after-save="handleAfterSave"
      @cancel="handleCancelForm"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import { ScheduledLeadExportSetting } from '@/api/openapi';
import { LeadExportApiService } from '@/api/user/resources/lead_export';
import { useWait } from '@/composable/vue-wait';
import ScheduledExportSettingForm from './ScheduledExportSettingForm.vue';
import ScheduledExportSettingShow from './ScheduledExportSettingShow.vue';
import ScheduledExportSettingList from './ScheduledExportSettingList.vue';
import type { TLeadListProps } from './types';

type TProps = TLeadListProps;

defineProps<TProps>();

const { doActionWithWait, wait } = useWait();
const api = new LeadExportApiService();

const settings = ref<ScheduledLeadExportSetting[]>([]);
const selectedSetting = ref<ScheduledLeadExportSetting>();
const currentView = ref<'list' | 'detail' | 'form'>('list');

const loading = computed(() => {
  return wait.is(['fetchSettingWait', 'putScheduledLeadExportSettingWait', 'deleteScheduledLeadExportSettingWait']);
});

onMounted(async () => {
  await fetchSettings();
});

const fetchSettings = async () => {
  await doActionWithWait('fetchSettingWait', async () => {
    const { data } = await api.getScheduledLeadExportSetting();
    settings.value = data.scheduledLeadExportSettings || [];
  });
};

const handleCreateNew = () => {
  selectedSetting.value = undefined;
  currentView.value = 'form';
};

const handleSelectSetting = (setting: ScheduledLeadExportSetting) => {
  selectedSetting.value = setting;
  currentView.value = 'detail';
};

const handleBackToList = () => {
  selectedSetting.value = undefined;
  currentView.value = 'list';
};

const handleCancelForm = () => {
  currentView.value = 'list';
};

const handleAfterDelete = async () => {
  await fetchSettings();
  currentView.value = 'list';
  selectedSetting.value = undefined;
};

const handleAfterSave = async () => {
  await fetchSettings();
  currentView.value = 'list';
};
</script>
